import React, { createContext, useContext, useState } from 'react';

const breadcrumbContext = createContext();

const BreadcrumbProvider = ({ children }) => {
  // const getBreadcrumbRoutes = (routes) => {
  //   return [...Object.keys(routes).map(key => ({ key, name: '', path: '' }))];
  // };

  const [breadcrumbRoutes, setBreadcrumbRoutes] = useState();
  //   [
  //   ...getBreadcrumbRoutes(collaborationRoutes),
  //   ...getBreadcrumbRoutes(multirunRoutes),
  // ]

  const updateBreadcrumb = ({ key, name, path, isExternal }) => {
    let activeRoutes = JSON.parse(localStorage.getItem('routes')) || [];
    activeRoutes.forEach((ar) => (ar.active = false));

    let activeCrumbIndex = activeRoutes.findIndex((br) => br.key === key);
    if (activeCrumbIndex >= 0) {
      activeRoutes.splice(activeCrumbIndex, 1, {
        appName: process.env.REACT_APP_MFE_APP_NAME,
        key,
        name: name ? name : activeRoutes[activeCrumbIndex].name,
        path,
        active: true,
        isExternal,
      });
    } else {
      activeRoutes.push({
        appName: process.env.REACT_APP_MFE_APP_NAME,
        key,
        name,
        path,
        active: true,
        isExternal,
      });
    }

    localStorage.setItem('routes', JSON.stringify(activeRoutes));
    setBreadcrumbRoutes(activeRoutes);
  };

  const removeBreadcrumb = (key) => {
    let activeRoutes = JSON.parse(localStorage.getItem('routes')) || [];
    activeRoutes = activeRoutes.filter((ar) => ar.key !== key);
    localStorage.setItem('routes', JSON.stringify(activeRoutes));
    setBreadcrumbRoutes(activeRoutes);
  };

  const value = {
    updateBreadcrumb,
    removeBreadcrumb,
    routes: breadcrumbRoutes,
  };
  return (
    <breadcrumbContext.Provider value={value}>
      {children}
    </breadcrumbContext.Provider>
  );
};

const useBreadcrumb = () => {
  return useContext(breadcrumbContext);
};

export { BreadcrumbProvider, useBreadcrumb };
